import { Box } from "@mui/material";
import AudioIcon from "components/AudioIcon";
import { dateFormatter } from "components/helpers";
import React from "react";
import { getFormattedDate } from "utils/helper";

export const columns = (
  currentPlaying,
  setCurrentPlaying,
  practice_id,
  npi
) => {
  return [
    {
      field: "id",
      headerName: "ID",
      width: 80,
    },
    {
      field: "note_text",
      headerName: "Note Text",
      flex: 2,
      renderCell: (params) => {
        const formattedText = params.value
          ? params.value.replace(/<br\s*\/?>/gi, "\n")
          : "";
        return (
          <Box
            sx={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: 1.4,
              py: 1,
            }}
          >
            {formattedText}
          </Box>
        );
      },
    },
    {
      field: "created_date",
      headerName: "Created Date",
      width: 120,
      valueFormatter: (value) => {
        if (!value) {
          return;
        }
        return getFormattedDate(value);
      },
      valueGetter: dateFormatter,
    },
    {
      field: "audio_duration",
      headerName: "Recording",
      width: 150,
      filterable: false,
      renderCell: (e) => {
        return (
          e.value && (
            <div className="list-duration ml-10">
              {e.value}
              <Box ml={2}>
                <AudioIcon
                  showPlayer={true}
                  id={e.row.id}
                  currentPlaying={currentPlaying}
                  setCurrentPlaying={setCurrentPlaying}
                  practice_id={practice_id}
                  npi={npi}
                  ext={e.row.file_extension}
                  row={e.row}
                />
              </Box>
            </div>
          )
        );
      },
    },
  ];
};
